var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticClass:"banners"},[_c('Banner',{attrs:{"src":_vm.src}})],1),_c('div',{staticClass:"union_container"},[_c('div',{staticClass:"union",domProps:{"innerHTML":_vm._s(_vm.text)}})]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }